// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/search/search.v2.proto (package no.jotta.openapi.search.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { AutoCompleteSearchQueryRequest, AutoCompleteSearchQueryResponse, FindSimilarPhotosRequest, FindSimilarPhotosResponse, GetWaitlistStatusRequest, GetWaitlistStatusResponse, JoinWaitlistRequest, JoinWaitlistResponse, PhotoSearchQuerySuggestionsRequest, PhotoSearchQuerySuggestionsResponse, PhotoSearchRequest, PhotoSearchResponse } from "./search.v2_pb.js";
import { PingRequest, PingResponse } from "../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.PhotoSearch
 */
export const photoSearch = {
    localName: "photoSearch",
    name: "PhotoSearch",
    kind: MethodKind.Unary,
    I: PhotoSearchRequest,
    O: PhotoSearchResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.PhotoSearchQuerySuggestions
 */
export const photoSearchQuerySuggestions = {
    localName: "photoSearchQuerySuggestions",
    name: "PhotoSearchQuerySuggestions",
    kind: MethodKind.Unary,
    I: PhotoSearchQuerySuggestionsRequest,
    O: PhotoSearchQuerySuggestionsResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.FindSimilarPhotos
 */
export const findSimilarPhotos = {
    localName: "findSimilarPhotos",
    name: "FindSimilarPhotos",
    kind: MethodKind.Unary,
    I: FindSimilarPhotosRequest,
    O: FindSimilarPhotosResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.AutoCompleteSearchQuery
 */
export const autoCompleteSearchQuery = {
    localName: "autoCompleteSearchQuery",
    name: "AutoCompleteSearchQuery",
    kind: MethodKind.Unary,
    I: AutoCompleteSearchQueryRequest,
    O: AutoCompleteSearchQueryResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.GetWaitlistStatus
 */
export const getWaitlistStatus = {
    localName: "getWaitlistStatus",
    name: "GetWaitlistStatus",
    kind: MethodKind.Unary,
    I: GetWaitlistStatusRequest,
    O: GetWaitlistStatusResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.JoinWaitlist
 */
export const joinWaitlist = {
    localName: "joinWaitlist",
    name: "JoinWaitlist",
    kind: MethodKind.Unary,
    I: JoinWaitlistRequest,
    O: JoinWaitlistResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.search.v2.SearchService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.search.v2.SearchService"
    }
};
